// extracted by mini-css-extract-plugin
export default {"interview":"InterviewApp-module__interview__TI3dJ","content":"InterviewApp-module__content__hmtwW"};